import { Typography } from "antd";
import React from "react";

type Props = { text: string; search: string };

const HighlightText = ({ text, search }: Props): JSX.Element => {
  if (!search) {
    return <span>{text}</span>;
  }

  const regex = new RegExp(`(${search})`, "gi");
  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <Typography.Text key={index} mark>
            {part}
          </Typography.Text>
        ) : (
          part
        )
      )}
    </span>
  );
};

export default HighlightText;
